// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import OperatingManualContent from "../OperatingManualContent/OperatingManualContent";
import GradientHeader from "src/components/shared/displays/GradientHeader/GradientHeader";
import AccountRegistration from "./AccountRegistration/AccountRegistration";
import ConfigureClinicSettings from "./ConfigureClinicSettings/ConfigureClinicSettings";
import TurningOnVRDevice from "./TurningOnVRDevice/TurningOnVRDevice";
import CreateSelectPatient from "./CreateSelectPatient/CreateSelectPatient";
import CreateAnExam from "./CreateAnExam/CreateAnExam";
import LaunchAnExam from "./LaunchAnExam/LaunchAnExam";
import LiveMonitorResults from "./LiveMonitorResults/LiveMonitorResults";
import ProgressionAnalysis from "./ProgressionAnalysis/ProgressionAnalysis";
import ExternalExams from "./ExternalExams/ExternalExams";
import KnowledgeHub from "./KnowledgeHub/KnowledgeHub";

type InstructionsForUseType = {
  title: string;
  handleSelectNavbarOption: (option: {
    route: string;
    label: string;
    subRoutes?: Array<{ route: string; label: string }>;
  }) => void;
};

const InstructionsForUse = ({
  title,
  handleSelectNavbarOption,
}: InstructionsForUseType) => {
  const { t } = useTranslation("operating-manual");

  return (
    <OperatingManualContent title={title}>
      <Box
        id="account-registration"
        sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        <GradientHeader
          header={`6.1 ${t("Account Registration & Initial Set Up")}`}
        />
        <Box sx={{ mx: "20px" }}>
          <AccountRegistration
            handleSelectNavbarOption={handleSelectNavbarOption}
          />
        </Box>
      </Box>

      <Box
        id="configure-settings"
        sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        <GradientHeader header={`6.2 ${t("Configure Clinic Settings")}`} />
        <Box sx={{ mx: "20px" }}>
          <ConfigureClinicSettings />
        </Box>
      </Box>

      <Box
        id="turning-on-the-vr-device"
        sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        <GradientHeader header={`6.3 ${t("Turning On the VR Device")}`} />
        <Box sx={{ mx: "20px" }}>
          <TurningOnVRDevice />
        </Box>
      </Box>

      <Box
        id="create-select-patient"
        sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        <GradientHeader header={`6.4 ${t("Create / Select a Patient")}`} />
        <Box sx={{ mx: "20px" }}>
          <CreateSelectPatient />
        </Box>
      </Box>

      <Box
        id="create-an-exam"
        sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        <GradientHeader header={`6.5 ${t("Create an Exam")}`} />
        <Box sx={{ mx: "20px" }}>
          <CreateAnExam />
        </Box>
      </Box>

      <Box
        id="launching-an-exam"
        sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        <GradientHeader header={`6.6 ${t("Launching an Exam")}`} />
        <Box sx={{ mx: "20px" }}>
          <LaunchAnExam />
        </Box>
      </Box>

      <Box
        id="viewing-results"
        sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        <GradientHeader header={`6.7 ${t("Live Monitor & View Results")}`} />
        <Box sx={{ mx: "20px" }}>
          <LiveMonitorResults />
        </Box>
      </Box>

      <Box
        id="progression-analysis"
        sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        <GradientHeader header={`6.8 ${t("Progression Analysis")}`} />
        <Box sx={{ mx: "20px" }}>
          <ProgressionAnalysis />
        </Box>
      </Box>

      <Box
        id="external-exams"
        sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        <GradientHeader header={`6.9 ${t("External Exams")}`} />
        <Box sx={{ mx: "20px" }}>
          <ExternalExams />
        </Box>
      </Box>

      <Box
        id="tutorial-hub"
        sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        <GradientHeader header={`6.10 ${t("Knowledge Hub")}`} />
        <Box sx={{ mx: "20px" }}>
          <KnowledgeHub />
        </Box>
      </Box>
    </OperatingManualContent>
  );
};

export default InstructionsForUse;
